"use client";

import { useEffect } from "react";
import { Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-3">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== "Privacy Policy" && item.label !== "Terms of Service");
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-3">
        {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <Tooltip>
              <TooltipTrigger asChild>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-transparent text-foreground/70 hover:bg-primary-light hover:text-primary transition-all duration-200 focus-ring">
                    <span className="sr-only">{item.label}</span>
                    <span className="text-base font-medium" aria-hidden="true">
                      {item.label.charAt(0)}
                    </span>
                  </Link>
                </NavigationMenuLink>
              </TooltipTrigger>
              <TooltipContent className="bg-primary text-white">
                <p>{item.label}</p>
              </TooltipContent>
            </Tooltip>
          </NavigationMenuItem>)}
        
        <NavigationMenuItem data-index={filteredMenuItems.length}>
          <Tooltip>
            <TooltipTrigger asChild>
              <NavigationMenuLink asChild>
                <Link to="tel:+19494944522" className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-transparent text-foreground/70 hover:bg-primary-light hover:text-primary transition-all duration-200 focus-ring">
                  <span className="sr-only">Call Us</span>
                  <Phone className="h-4 w-4" aria-hidden="true" />
                </Link>
              </NavigationMenuLink>
            </TooltipTrigger>
            <TooltipContent className="bg-primary text-white">
              <p>Call Us</p>
            </TooltipContent>
          </Tooltip>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  useEffect(() => {
    const GA_MEASUREMENT_ID = 'G-QKRC45LLH7';
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
      return;
    }
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(gtagScript);
    const initScript = document.createElement('script');
    initScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(initScript);
    return () => {
      if (gtagScript.parentNode) {
        gtagScript.parentNode.removeChild(gtagScript);
      }
      if (initScript.parentNode) {
        initScript.parentNode.removeChild(initScript);
      }
    };
  }, []);
  useEffect(() => {
    if (document.querySelector('script[src*="cdn.ally.ac"]')) {
      return;
    }
    const allyScript = document.createElement('script');
    allyScript.async = true;
    allyScript.src = 'https://cdn.ally.ac/ally.js';
    allyScript.setAttribute('data-ally', 'true');
    document.head.appendChild(allyScript);
    const initScript = document.createElement('script');
    initScript.innerHTML = `
      (function() {
        if (window.Ally) {
          window.Ally.init();
        } else {
          document.addEventListener('DOMContentLoaded', function() {
            if (window.Ally) {
              window.Ally.init();
            }
          });
        }
      })();
    `;
    document.head.appendChild(initScript);
    return () => {
      if (allyScript.parentNode) {
        allyScript.parentNode.removeChild(allyScript);
      }
      if (initScript.parentNode) {
        initScript.parentNode.removeChild(initScript);
      }
    };
  }, []);
  return <header className="bg-background border-b border-border shadow-soft sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-[auto_1fr_auto] items-center gap-4 py-3">
          {}
          <div className="flex items-center">
            <Link to="/" className="focus-ring rounded-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1427264/img/romero_welding_logo.png" alt="Romero Welding Inc. - Industrial and Commercial Welding Services" className="h-7" style={{
              filter: "brightness(1.3)"
            }} />
            </Link>
          </div>

          {}
          <div className="flex justify-center">
            <MenuProvider menu_id="3">
              <HeaderMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <Link to="mailto:romeroweldinginc@gmail.com" className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-transparent text-foreground/70 hover:bg-primary-light hover:text-primary transition-all duration-200 focus-ring" aria-label="Contact Information - Email and Phone">
                  <Mail className="h-4 w-4" aria-hidden="true" />
                </Link>
              </TooltipTrigger>
              <TooltipContent className="max-w-xs bg-primary text-white">
                <div className="space-y-1.5">
                  <div className="flex items-center gap-2">
                    <Phone className="h-3.5 w-3.5" aria-hidden="true" />
                    <span className="text-xs">19494944522</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Mail className="h-3.5 w-3.5" aria-hidden="true" />
                    <span className="text-xs">romeroweldinginc@gmail.com</span>
                  </div>
                </div>
              </TooltipContent>
            </Tooltip>
          </div>
        </div>
      </div>
    </header>;
}